import type {ComponentPropsWithoutRef} from 'react';
import {colors} from '../../styles/themes';

type PrTimesLogoVariant = 'colored' | 'white' | 'black';

const variantToColor = {
  colored: colors.primaryBlue[900],
  white: colors.white,
  black: '#000000',
} satisfies Record<PrTimesLogoVariant, string>;

type PrTimesLogoProps = ComponentPropsWithoutRef<'svg'> & {
  readonly variant?: PrTimesLogoVariant;
};

export function PrTimesLogo({variant = 'colored', ...props}: PrTimesLogoProps) {
  const color = variantToColor[variant];

  return (
    <svg
      width='121'
      height='24'
      viewBox='0 0 121 24'
      fill='none'
      {...props}
      aria-hidden
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M37.5534 2.10983V6.25034H43.2108V23.1138L47.4077 18.3457V18.2685V6.25034L53.0875 6.25113V2.10983H37.5534Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.3485 8.89319C11.3404 10.2583 10.8005 10.8671 10.1562 11.2008C9.50514 11.5313 8.722 11.5376 8.29063 11.5368L4.15928 11.536V6.25038H8.29063C8.69388 6.2488 9.47721 6.25552 10.1356 6.58599C10.7888 6.92081 11.3404 7.53099 11.3485 8.89319ZM13.3683 3.99079C12.0433 2.77516 10.2382 2.05338 8.29063 2.05338H0V21.3424H4.15928V15.7314H8.29063V15.7306C10.2382 15.7306 12.0441 15.0073 13.3691 13.7893C14.6975 12.579 15.5145 10.8357 15.5137 8.90583V8.88766C15.5145 6.95024 14.7015 5.20325 13.3683 3.99079Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M119.029 10.8711L119.029 10.8707C117.819 9.78923 116.268 9.62567 114.494 9.62488L111.923 9.62567C111.521 9.62646 110.905 9.60928 110.418 9.3989C109.934 9.17944 109.578 8.83435 109.568 8.03414C109.577 7.1085 109.944 6.71639 110.408 6.48508C110.877 6.25831 111.469 6.24705 111.843 6.24883H111.887L119.466 6.24962V2.05301H111.923C110.205 2.05301 108.601 2.45993 107.402 3.53748C106.208 4.59606 105.428 6.32547 105.425 8.03256L105.426 8.03414C105.428 9.73708 106.135 11.5022 107.333 12.5668C108.545 13.6477 110.056 13.7964 111.923 13.7956H114.536H114.557C114.889 13.7948 115.468 13.8027 115.937 14.0034C116.402 14.2122 116.76 14.5492 116.769 15.3536C116.76 16.2944 116.371 16.696 115.89 16.9323C115.404 17.1622 114.812 17.1709 114.483 17.1689H106.452H106.248V21.3424H114.494C116.21 21.3424 117.82 20.9179 119.016 19.8479C120.208 18.7932 120.983 17.0913 121 15.4006V15.3536C120.998 13.6427 120.225 11.9321 119.029 10.8711Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M55.611 5.01282V21.3428H60.0129V0L55.611 4.93479V5.01282Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28.776 8.89357C28.7677 10.2587 28.2272 10.8671 27.5829 11.2012C26.9317 11.5308 26.1481 11.5383 25.7169 11.5368H21.5866V6.25036H25.7169C26.1198 6.24878 26.9033 6.2555 27.5619 6.58598C28.2155 6.92159 28.7677 7.52999 28.776 8.89357ZM28.3104 15.2771C29.2403 14.944 30.0878 14.4405 30.7958 13.7892C32.1228 12.5788 32.9406 10.8357 32.9406 8.90581V8.88764C32.9406 6.95023 32.1278 5.20324 30.7948 3.99077C29.4712 2.77436 27.6643 2.05356 25.7169 2.05356H17.4269V21.3424H21.5866V13.5546L28.3312 21.355H33.5257L33.2377 21.0186L28.3104 15.2771Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M87.6914 3.52716C86.7177 4.40678 86.1679 5.60679 86.1685 6.90459L86.1679 16.5259C86.1679 17.8213 86.7169 19.0273 87.6946 19.8988C88.6407 20.7729 89.7946 21.3554 91.3329 21.3554H91.3428H103.602V17.1963H103.397H90.9313C90.7738 17.1888 90.7017 17.1692 90.5369 17.0329C90.4118 16.9164 90.3208 16.7505 90.3201 16.5259V13.809H101.717L101.739 9.64992H90.3201V6.94331C90.3201 6.72108 90.4133 6.54587 90.5419 6.43407C90.7017 6.29974 90.7714 6.28216 90.9404 6.27248H103.602V2.0741H91.3377C89.7871 2.07805 88.6429 2.66216 87.6914 3.52716Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M77.8506 2.10199H68.203C66.9044 2.1012 65.6944 2.64995 64.8208 3.62498C63.9426 4.57136 63.3583 5.72457 63.3607 7.26276V21.3392H67.531V21.1348V6.85229C67.5382 6.69643 67.5584 6.62256 67.6944 6.45939C67.8111 6.33416 67.9788 6.24309 68.203 6.2423H70.9264L70.9272 21.3177L75.0972 21.34V6.2423H77.8128C78.032 6.2423 78.2093 6.33593 78.3226 6.46473C78.4569 6.62414 78.4741 6.69327 78.484 6.86276L78.4832 21.3392H82.6926V7.25802C82.6904 5.71113 82.1038 4.57057 81.2368 3.62063C80.3541 2.64995 79.1501 2.1012 77.8506 2.10199Z'
        fill={color}
      />
    </svg>
  );
}
